<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9686 4.4999C14.9686 6.416 13.4161 7.96855 11.5019 7.96855C9.58768 7.96855 8.03516 6.416 8.03516 4.4999C8.03516 2.5838 9.58768 1.03125 11.5019 1.03125C13.4161 1.03125 14.9686 2.5838 14.9686 4.4999Z" stroke="currentColor" stroke-width="2.0625"/>
<circle cx="4.5" cy="19.5" r="3.5" stroke="currentColor" stroke-width="2"/>
<circle cx="19.5" cy="19.5" r="3.5" stroke="currentColor" stroke-width="2"/>
</svg>
